import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DepositDto } from '../../../_core/_model/deposits';
import { ApiService } from '../../../_core/_services/api.service';

@Component({
  selector: 'app-deposit-details-modal',
  standalone: false,
  templateUrl: './deposit-details-modal.html',
  styleUrl: './deposit-details-modal.css'
})
export class DepositDetailsModal {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() deposit: DepositDto | null = null;

  loadingReceipt = false;

  constructor(private api: ApiService) {}

  close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  get canShowReceiptActions(): boolean {
    if (!this.deposit) return false;

    const status = (this.deposit.status || '').toLowerCase();
    return !!this.deposit.receiptNumber && ['confirmed', 'completed', 'successful'].includes(status);
  }

  viewReceipt(): void {
    if (!this.deposit) return;

    this.loadingReceipt = true;

    this.api.getDepositReceipt(this.deposit.depositId).subscribe({
      next: (response) => {
        const blob = response.body;
        if (!blob) {
          this.loadingReceipt = false;
          return;
        }

        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank', 'noopener');

        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 10000);

        this.loadingReceipt = false;
      },
      error: () => {
        this.loadingReceipt = false;
      }
    });
  }

  downloadReceipt(): void {
    if (!this.deposit) return;

    this.loadingReceipt = true;

    this.api.getDepositReceipt(this.deposit.depositId).subscribe({
      next: (response) => {
        const blob = response.body;
        if (!blob) {
          this.loadingReceipt = false;
          return;
        }

        const contentDisposition = response.headers.get('content-disposition');
        const match = contentDisposition?.match(/filename="?([^"]+)"?/i);
        const fileName = match?.[1] || `deposit-receipt-${this.deposit?.receiptNumber || this.deposit?.depositId}.pdf`;

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(url);
        this.loadingReceipt = false;
      },
      error: () => {
        this.loadingReceipt = false;
      }
    });
  }

  badgeClass(status: string): string {
    switch ((status || '').toLowerCase()) {
      case 'completed':
      case 'confirmed':
      case 'successful':
        return 'bg-success-subtle text-success';
      case 'failed':
      case 'cancelled':
        return 'bg-danger-subtle text-danger';
      case 'processing':
      case 'pending':
      case 'initiated':
        return 'bg-warning-subtle text-warning';
      default:
        return 'bg-secondary-subtle text-secondary';
    }
  }

  prettyJson(value?: string | null): string {
    if (!value) return '-';

    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
}